// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Control_Semigroupoid from "../Control.Semigroupoid/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Leibniz from "../Data.Leibniz/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Monoid_Extra from "../Data.Monoid.Extra/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Data_Vault from "../Data.Vault/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Record from "../Record/index.js";
import * as Record_Builder from "../Record.Builder/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_Form_EditAsString from "../Restaumatic.Form.EditAsString/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_Form_GenerateId from "../Restaumatic.Form.GenerateId/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_ChoiceRef from "../Specular.ChoiceRef/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_FormField from "../Specular.FormField/index.js";
import * as Specular_MultiChoiceRef from "../Specular.MultiChoiceRef/index.js";
import * as Specular_Profiling from "../Specular.Profiling/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Specular_Select from "../Specular.Select/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var WithOptions = function (x) {
    return x;
};
var WithId = /* #__PURE__ */ (function () {
    function WithId(value0) {
        this.value0 = value0;
    };
    WithId.create = function (value0) {
        return new WithId(value0);
    };
    return WithId;
})();
var Undefined = /* #__PURE__ */ (function () {
    function Undefined() {

    };
    Undefined.value = new Undefined();
    return Undefined;
})();
var Invalid = /* #__PURE__ */ (function () {
    function Invalid(value0) {
        this.value0 = value0;
    };
    Invalid.create = function (value0) {
        return new Invalid(value0);
    };
    return Invalid;
})();
var Valid = /* #__PURE__ */ (function () {
    function Valid(value0) {
        this.value0 = value0;
    };
    Valid.create = function (value0) {
        return new Valid(value0);
    };
    return Valid;
})();
var InputRequired = /* #__PURE__ */ (function () {
    function InputRequired() {

    };
    InputRequired.value = new InputRequired();
    return InputRequired;
})();
var Strict = /* #__PURE__ */ (function () {
    function Strict() {

    };
    Strict.value = new Strict();
    return Strict;
})();
var Lax = /* #__PURE__ */ (function () {
    function Lax() {

    };
    Lax.value = new Lax();
    return Lax;
})();
var RefWithOptions = function (x) {
    return x;
};
var FormDefM = function (x) {
    return x;
};
var FormField = function (x) {
    return x;
};
var MappedField = function (x) {
    return x;
};
var Attribute = function (x) {
    return x;
};
var queryFormField = function (dictTypeEquals) {
    return {
        queryWith: function (v) {
            var $494 = Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Type_Equality.from(dictTypeEquals));
            return function ($495) {
                return $494(Specular_FormField.finalValueNoErr($495));
            };
        }
    };
};
var mergeRef = function (dictTypeEquals) {
    return {
        merge: function (x) {
            return function (ref) {
                return Specular_Ref.write(Effect_Class.monadEffectEffect)(ref)(Type_Equality.to(dictTypeEquals)(x));
            };
        }
    };
};
var isRefLikeRef = {
    readRefLike: /* #__PURE__ */ (function () {
        var $496 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.Just.create);
        return function ($497) {
            return $496(Specular_Ref.value($497));
        };
    })(),
    writeRefLike: function (ref) {
        return function (v) {
            if (v instanceof Valid) {
                return Specular_Ref.write(Effect_Class.monadEffectEffect)(ref)(v.value0.value);
            };
            return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
        };
    },
    touchRefLike: function (v) {
        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
    }
};
var isCheckboxFieldRefBoolean = {
    checkboxInput: function (f) {
        return Control_Applicative.pure(Specular_FRP_Host.applicativeHost)({
            onChange: function (value) {
                return Specular_Ref.write(Effect_Class.monadEffectEffect)(f)(value);
            },
            displayedValue: Specular_Ref.value(f)
        });
    }
};
var isCheckboxFieldFormFieldB = {
    checkboxInput: function (field) {
        return Control_Applicative.pure(Specular_FRP_Host.applicativeHost)({
            onChange: function (value) {
                return Specular_Ref.write(Effect_Class.monadEffectEffect)(Specular_FormField.editRef(field))(value);
            },
            displayedValue: Specular_Ref.value(Specular_FormField.editRef(field))
        });
    }
};
var hasFieldIdWithId = {
    getFieldId: function (v) {
        return v.value0.id;
    }
};
var hasFieldIdString = {
    getFieldId: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn)
};
var hasFieldIdFormField = function () {
    return {
        getFieldId: function (v) {
            return "";
        }
    };
};
var hasErrorsRef = {
    displayedErrors: function (v) {
        return Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)([  ]);
    }
};
var addContextRef = {
    addContext: function (v) {
        return function (v1) {
            return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
        };
    }
};
var addContextFormField1 = {
    addContext: function (v) {
        return function (v1) {
            return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
        };
    }
};
var addContextEffect = {
    addContext: function (v) {
        return function (v1) {
            return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
        };
    }
};
var addContextDynamic = {
    addContext: function (v) {
        return function (v1) {
            return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
        };
    }
};
var writeValue = function (v) {
    return function (v1) {
        return function __do() {
            var handler = Effect_Ref.read(v.onWriteValue)();
            return handler(v)(v1)();
        };
    };
};
var writeValidValue = function (field) {
    return function (value) {
        return writeValue(field)(new Valid({
            value: value,
            editValue: Data_Maybe.Nothing.value
        }));
    };
};
var writeRefLike = function (dict) {
    return dict.writeRefLike;
};
var writeRef = function (ref) {
    return function (value) {
        return Specular_Callback.triggerCallback(Specular_Ref.set(Effect_Class.monadEffectEffect)(ref))(value);
    };
};
var writeValueNoTouch = function (v) {
    return function (v1) {
        return function __do() {
            writeRef(v.value)(v1)();
            return v.userEdit.fire(Data_Unit.unit)();
        };
    };
};
var isTextFieldFormFieldStrin = {
    textInput: function (f) {
        return {
            onChange: function (value) {
                return writeRef(Specular_FormField.editRef(f))(value);
            },
            onTouch: Specular_Callback.triggerCallback(Specular_FormField.focusOutCallback(f))(Data_Unit.unit),
            displayedValue: Specular_Ref.value(Specular_FormField.editRef(f)),
            placeholder: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)("")
        };
    }
};
var isTextFieldRefString = {
    textInput: function (f) {
        return {
            onChange: function (value) {
                return writeRef(f)(value);
            },
            onTouch: Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit),
            displayedValue: Specular_Ref.value(f),
            placeholder: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)("")
        };
    }
};
var withId = function (id) {
    return function (field) {
        return new WithId({
            id: id,
            field: field
        });
    };
};
var withFinal_ = function (dictMonadReplace) {
    return function (dictMonadFRP) {
        return function (f) {
            return function (block) {
                return Specular_FRP_Replaceable.withDynamic_(dictMonadReplace)(dictMonadFRP)(Restaumatic_Form_Final.unFinal(f))(Data_Foldable.traverse_(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(Data_Foldable.foldableMaybe)(block));
            };
        };
    };
};
var validateWhenJust = function (validation) {
    return function (paramF) {
        return function (value) {
            return Restaumatic_Form_Final.bindFinal(paramF)(function (v) {
                if (v instanceof Data_Maybe.Nothing) {
                    return Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)([  ]);
                };
                if (v instanceof Data_Maybe.Just) {
                    return validation(Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)(v.value0))(value);
                };
                throw new Error("Failed pattern match at Restaumatic.Form (line 764, column 3 - line 766, column 48): " + [ v.constructor.name ]);
            });
        };
    };
};
var validateTrue = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_Final.functorFinal)(function (v) {
    return Data_Monoid_Extra.mwhen(Data_Monoid.monoidArray)(v === false)([ Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.required) ]);
});
var validateJust = function (validation) {
    return function (value) {
        return Restaumatic_Form_Final.bindFinal(value)(function (v) {
            if (v instanceof Data_Maybe.Just) {
                return validation(Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)(v.value0));
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)([  ]);
            };
            throw new Error("Failed pattern match at Restaumatic.Form (line 739, column 51 - line 741, column 21): " + [ v.constructor.name ]);
        });
    };
};
var userEdit = function (v) {
    return v.userEdit.event;
};
var uniqFinal = function (dictMonadFRP) {
    return function (dictEq) {
        var $498 = Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(Restaumatic_Form_Final.makeFinalV);
        var $499 = Specular_FRP_Base.uniqDynBy(dictMonadFRP)(Data_Eq.eq(Data_Validation_Semigroup.eqV(Restaumatic_Form_Final.eqFormErrors)(dictEq)));
        return function ($500) {
            return $498($499(Restaumatic_Form_Final.unFinalV($500)));
        };
    };
};
var unFinalWithDefault = function (def) {
    var $501 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.fromMaybe(def));
    return function ($502) {
        return $501(Restaumatic_Form_Final.unFinal($502));
    };
};
var unFinalFromContextDef = function (d) {
    return function (key) {
        return function (ctxRef) {
            return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(ctxRef))(function (context1) {
                return Data_Maybe.maybe(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(d))(unFinalWithDefault(d))(Data_Vault.lookup(key)(context1));
            });
        };
    };
};
var unFinalFromContext = function (key) {
    return function (ctxRef) {
        return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(ctxRef))(function (context1) {
            return Data_Maybe.maybe(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Maybe.Nothing.value))(Restaumatic_Form_Final.unFinal)(Data_Vault.lookup(key)(context1));
        });
    };
};
var touchRefLike = function (dict) {
    return dict.touchRefLike;
};
var touch = function (v) {
    return writeRef(v.touched)(true);
};
var toRecord = function (dict) {
    return dict.toRecord;
};
var textInput = function (dict) {
    return dict.textInput;
};
var isTextFieldWithId = function (dictIsTextField) {
    return {
        textInput: function (v) {
            return textInput(dictIsTextField)(v.value0.field);
        }
    };
};
var tagErrors = function (fieldName) {
    return function (errors) {
        return Data_Newtype.wrap()(Data_Map_Internal.insertWith(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))(Data_Semigroup.append(Data_Semigroup.semigroupArray))(new Data_Maybe.Just(fieldName))(Data_Functor.mapFlipped(Data_Functor.functorArray)(Data_Maybe.fromMaybe([  ])(Data_Map_Internal.lookup(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))(Data_Maybe.Nothing.value)(Data_Newtype.unwrap()(errors))))(function (error) {
            var $280 = {};
            for (var $281 in error) {
                if ({}.hasOwnProperty.call(error, $281)) {
                    $280[$281] = error[$281];
                };
            };
            $280.fieldName = new Data_Maybe.Just(fieldName);
            return $280;
        }))(Data_Map_Internal["delete"](Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))(Data_Maybe.Nothing.value)(Data_Newtype.unwrap()(errors))));
    };
};
var singleOption = function (label) {
    return function (key) {
        return new Specular_Select.SingleOption({
            label: label,
            key: key,
            disabled: false
        });
    };
};
var withOptions = function (field) {
    return function (label) {
        return {
            field: field,
            toOption: function (a) {
                return singleOption(label(a))(a);
            }
        };
    };
};
var selectWriteValue = function (dict) {
    return dict.selectWriteValue;
};
var selectTouch = function (dict) {
    return dict.selectTouch;
};
var selectReadValue = function (dict) {
    return dict.selectReadValue;
};
var selectGetOptions = function (dict) {
    return dict.selectGetOptions;
};
var selectInput = function (dictShow) {
    return function (dictEq) {
        return function (dictIsSelectField) {
            return function (ff) {
                var contains = function (v) {
                    return function (v1) {
                        if (v1 instanceof Specular_Select.SingleOption) {
                            return Data_Eq.eq(dictEq)(v1.value0.key)(v);
                        };
                        if (v1 instanceof Specular_Select.OptGroup) {
                            return Data_Array.any(function (o) {
                                return Data_Eq.eq(dictEq)(o.key)(v);
                            })(v1.value0.options);
                        };
                        throw new Error("Failed pattern match at Restaumatic.Form (line 1013, column 3 - line 1013, column 47): " + [ v.constructor.name, v1.constructor.name ]);
                    };
                };
                var extraOption = function (stdOptions) {
                    return function (value) {
                        if (value instanceof Data_Maybe.Just && Data_Array.any(contains(value.value0))(stdOptions)) {
                            return [  ];
                        };
                        if (value instanceof Data_Maybe.Just) {
                            return [ new Specular_Select.SingleOption({
                                key: new Data_Maybe.Just(value.value0),
                                label: Data_Show.show(dictShow)(value.value0),
                                disabled: false
                            }) ];
                        };
                        if (value instanceof Data_Maybe.Nothing) {
                            return [ new Specular_Select.SingleOption({
                                key: Data_Maybe.Nothing.value,
                                label: "",
                                disabled: false
                            }) ];
                        };
                        throw new Error("Failed pattern match at Restaumatic.Form (line 1005, column 5 - line 1011, column 70): " + [ value.constructor.name ]);
                    };
                };
                return Control_Applicative.pure(Specular_FRP_Host.applicativeHost)({
                    onChange: function (v) {
                        if (v instanceof Data_Maybe.Just) {
                            return selectWriteValue(dictIsSelectField)(ff)(v.value0);
                        };
                        if (v instanceof Data_Maybe.Nothing) {
                            return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
                        };
                        throw new Error("Failed pattern match at Restaumatic.Form (line 990, column 9 - line 995, column 22): " + [ v.constructor.name ]);
                    },
                    displayedValue: Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.Just.create)(selectReadValue(dictIsSelectField)(ff)),
                    displayedOptions: Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v) {
                        return function (v1) {
                            return Data_Semigroup.append(Data_Semigroup.semigroupArray)(extraOption(v)(v1))(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Specular_Select.functorOption)(Data_Maybe.Just.create))(v));
                        };
                    })(selectGetOptions(dictIsSelectField)(ff)))(selectReadValue(dictIsSelectField)(ff)),
                    onTouch: selectTouch(dictIsSelectField)(ff)
                });
            };
        };
    };
};
var isSelectFieldWithId = function (dictIsSelectField) {
    return {
        selectWriteValue: function (v) {
            return selectWriteValue(dictIsSelectField)(v.value0.field);
        },
        selectReadValue: function (v) {
            return selectReadValue(dictIsSelectField)(v.value0.field);
        },
        selectGetOptions: function (v) {
            return selectGetOptions(dictIsSelectField)(v.value0.field);
        },
        selectTouch: function (v) {
            return selectTouch(dictIsSelectField)(v.value0.field);
        }
    };
};
var requiredError = function (v) {
    return Restaumatic_Form_Final.userVisibleError(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.required));
};
var readValueState = function (v) {
    return v.readValueState;
};
var isTextFieldFormField = function (dictEditAsString) {
    return {
        textInput: function (v) {
            var parse$prime = function (str) {
                var v1 = Restaumatic_Form_EditAsString.parse(dictEditAsString)(str);
                if (v1 instanceof Data_Either.Left) {
                    return new Invalid({
                        error: Restaumatic_Form_Final.userVisibleError(v1.value0),
                        editValue: new Data_Maybe.Just(str)
                    });
                };
                if (v1 instanceof Data_Either.Right) {
                    return new Valid({
                        value: v1.value0,
                        editValue: new Data_Maybe.Just(str)
                    });
                };
                throw new Error("Failed pattern match at Restaumatic.Form (line 849, column 7 - line 853, column 47): " + [ v1.constructor.name ]);
            };
            return {
                displayedValue: Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(readValueState(v))(function (v1) {
                    if (v1 instanceof Undefined) {
                        return "";
                    };
                    if (v1 instanceof Invalid) {
                        return Data_Maybe.fromMaybe("")(v1.value0.editValue);
                    };
                    if (v1 instanceof Valid && v1.value0.editValue instanceof Data_Maybe.Just) {
                        return v1.value0.editValue.value0;
                    };
                    if (v1 instanceof Valid && v1.value0.editValue instanceof Data_Maybe.Nothing) {
                        return Restaumatic_Form_EditAsString.toString(dictEditAsString)(v1.value0.value);
                    };
                    if (v1 instanceof InputRequired) {
                        return "";
                    };
                    throw new Error("Failed pattern match at Restaumatic.Form (line 830, column 9 - line 840, column 15): " + [ v1.constructor.name ]);
                }),
                onChange: function (str) {
                    return writeValue(v)(parse$prime(str));
                },
                onTouch: touch(v),
                placeholder: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)("")
            };
        }
    };
};
var readValue = function (field) {
    return Restaumatic_Form_Final.makeFinalV(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(readValueState(field))(function (v) {
        if (v instanceof Undefined) {
            return Data_Validation_Semigroup.invalid(requiredError(Data_Unit.unit));
        };
        if (v instanceof Valid) {
            return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Restaumatic_Form_Final.semigroupFormErrors))(v.value0.value);
        };
        if (v instanceof Invalid) {
            return Data_Validation_Semigroup.invalid(v.value0.error);
        };
        if (v instanceof InputRequired) {
            return Data_Validation_Semigroup.invalid(requiredError(Data_Unit.unit));
        };
        throw new Error("Failed pattern match at Restaumatic.Form (line 151, column 3 - line 159, column 37): " + [ v.constructor.name ]);
    }));
};
var isCheckboxFieldFormFieldB1 = {
    checkboxInput: function (v) {
        return Effect_Class.liftEffect(Specular_FRP_Host.monadEffectHost)(function __do() {
            var initial = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(Restaumatic_Form_Final.unFinal(readValue(v)))();
            Control_Applicative.when(Effect.applicativeEffect)(Data_Maybe.isNothing(initial))(writeRef(v.value)(new Valid({
                value: false,
                editValue: Data_Maybe.Nothing.value
            })))();
            return {
                displayedValue: Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.fromMaybe(false))(Restaumatic_Form_Final.unFinal(readValue(v))),
                onChange: writeValidValue(v)
            };
        });
    }
};
var isRefLikeFormField = {
    readRefLike: function (f) {
        return Restaumatic_Form_Final.unFinal(readValue(f));
    },
    writeRefLike: writeValue,
    touchRefLike: touch
};
var readRefLike = function (dict) {
    return dict.readRefLike;
};
var isRefLikeFormField1 = {
    readRefLike: /* #__PURE__ */ (function () {
        var $503 = readRefLike(isRefLikeRef);
        return function ($504) {
            return $503(Specular_FormField.editRef($504));
        };
    })(),
    writeRefLike: /* #__PURE__ */ (function () {
        var $505 = writeRefLike(isRefLikeRef);
        return function ($506) {
            return $505(Specular_FormField.editRef($506));
        };
    })(),
    touchRefLike: function (field) {
        return Specular_FormField.focusOutCallback(field)(Data_Unit.unit);
    }
};
var isRefLikeWithId = function (dictIsRefLike) {
    return {
        writeRefLike: function (v) {
            return writeRefLike(dictIsRefLike)(v.value0.field);
        },
        readRefLike: function (v) {
            return readRefLike(dictIsRefLike)(v.value0.field);
        },
        touchRefLike: function (v) {
            return touchRefLike(dictIsRefLike)(v.value0.field);
        }
    };
};
var queryWith = function (dict) {
    return dict.queryWith;
};
var queryT2T2 = function (dictQuery) {
    return function (dictQuery1) {
        return {
            queryWith: function (strictness) {
                return function (v) {
                    return Control_Apply.apply(Restaumatic_Form_Final.applyFinal)(Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Data_Tuple_T2.T2.create)(queryWith(dictQuery)(strictness)(v.value0)))(queryWith(dictQuery1)(strictness)(v.value1));
                };
            }
        };
    };
};
var queryUnit = function (dictTypeEquals) {
    return {
        queryWith: function (v) {
            return function (v1) {
                return Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)(Data_Unit.unit);
            };
        }
    };
};
var queryRef = function (dictTypeEquals) {
    return {
        queryWith: function (v) {
            var $507 = Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Type_Equality.from(dictTypeEquals));
            return function ($508) {
                return $507(Restaumatic_Form_Final.liftDynamic(Specular_Ref.value($508)));
            };
        }
    };
};
var queryRecordNil = {
    queryRecord: function (v) {
        return function (v1) {
            return function (v2) {
                return Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)(Control_Category.identity(Record_Builder.categoryBuilder));
            };
        };
    }
};
var queryRecord = function (dict) {
    return dict.queryRecord;
};
var queryRecordCons = function (dictIsSymbol) {
    return function (dictQueryRecord) {
        return function (dictQuery) {
            return function () {
                return function () {
                    return function () {
                        return function () {
                            return {
                                queryRecord: function (strictness) {
                                    return function (v) {
                                        return function (f) {
                                            return Control_Apply.apply(Restaumatic_Form_Final.applyFinal)(Data_Functor.map(Restaumatic_Form_Final.functorFinal)(function (v1) {
                                                return function (v2) {
                                                    return Control_Semigroupoid.composeFlipped(Record_Builder.semigroupoidBuilder)(v2)(Record_Builder.insert()()(dictIsSymbol)(Type_Proxy["Proxy"].value)(v1));
                                                };
                                            })(queryWith(dictQuery)(strictness)(Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(f))))(queryRecord(dictQueryRecord)(strictness)(Type_Proxy["Proxy"].value)(f));
                                        };
                                    };
                                }
                            };
                        };
                    };
                };
            };
        };
    };
};
var queryLaxWithDefault = function (dictQuery) {
    return function (def) {
        var $509 = unFinalWithDefault(def);
        var $510 = queryWith(dictQuery)(Lax.value);
        return function ($511) {
            return $509($510($511));
        };
    };
};
var queryLax = function (dictQuery) {
    return queryWith(dictQuery)(Lax.value);
};
var queryFormFieldI = function (dictTypeEquals) {
    return {
        queryWith: function (v) {
            return function (v1) {
                if (v instanceof Lax) {
                    return Restaumatic_Form_Final.makeFinalV(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Bifunctor.bimap(Data_Validation_Semigroup.bifunctorV)(tagErrors(v1.name))(Type_Equality.from(dictTypeEquals)))(Restaumatic_Form_Final.unFinalV(readValue(v1))));
                };
                if (v instanceof Strict) {
                    return Restaumatic_Form_Final.makeFinalV(Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v2) {
                        return function (v3) {
                            return Data_Bifunctor.lmap(Data_Validation_Semigroup.bifunctorV)(tagErrors(v1.name))(Data_Validation_Semigroup.andThen(v3)(function (value$prime) {
                                return Data_Validation_Semigroup.andThen(v2)(function (errors$prime) {
                                    var $354 = Data_Array["null"](errors$prime);
                                    if ($354) {
                                        return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Restaumatic_Form_Final.semigroupFormErrors))(Type_Equality.from(dictTypeEquals)(value$prime));
                                    };
                                    return Data_Validation_Semigroup.invalid(Data_Newtype.wrap()(Data_Map_Internal.singleton(new Data_Maybe.Just(v1.name))(Data_Functor.mapFlipped(Data_Functor.functorArray)(errors$prime)(function (message) {
                                        return {
                                            fieldName: new Data_Maybe.Just(v1.name),
                                            fieldLabel: Data_Maybe.Nothing.value,
                                            message: message,
                                            internal: false
                                        };
                                    }))));
                                });
                            }));
                        };
                    })(Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(v1.validations))(function (validations$prime) {
                        return Restaumatic_Form_Final.unFinalV(Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Data_Array.concat)(Data_Traversable.sequence(Data_Traversable.traversableArray)(Restaumatic_Form_Final.applicativeFinal)(validations$prime)));
                    })))(Restaumatic_Form_Final.unFinalV(readValue(v1))));
                };
                throw new Error("Failed pattern match at Restaumatic.Form (line 512, column 1 - line 533, column 18): " + [ v.constructor.name, v1.constructor.name ]);
            };
        }
    };
};
var readValidationErrors = function (v) {
    var getErrors = (function () {
        var $512 = Data_Functor.map(Data_Functor.functorArray)(function (v1) {
            return v1.message;
        });
        var $513 = Data_Maybe.fromMaybe([  ]);
        var $514 = Data_Map_Internal.lookup(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))(new Data_Maybe.Just(v.name));
        var $515 = Data_Newtype.unwrap();
        return function ($516) {
            return $512($513($514($515($516))));
        };
    })();
    return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Validation_Semigroup.validation(getErrors)(function (v1) {
        return [  ];
    }))(Restaumatic_Form_Final.unFinalV(queryWith(queryFormFieldI(Type_Equality.refl))(Strict.value)(v)));
};
var queryFinal = function (dictTypeEquals) {
    return {
        queryWith: function (v) {
            return Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Type_Equality.from(dictTypeEquals));
        }
    };
};
var queryDynamic = function (dictTypeEquals) {
    return {
        queryWith: function (v) {
            var $517 = Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Type_Equality.from(dictTypeEquals));
            return function ($518) {
                return $517(Restaumatic_Form_Final.liftDynamic($518));
            };
        }
    };
};
var query = function (dictQuery) {
    return queryWith(dictQuery)(Strict.value);
};
var optionForEq = function () {
    return Unsafe_Coerce.unsafeCoerce;
};
var readOptions = function () {
    return function (v) {
        return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(v.options))(function (optionsDef) {
            return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.maybe([  ])(Data_Leibniz.runLeibniz(optionForEq())))(Restaumatic_Form_Final.unFinal(optionsDef));
        });
    };
};
var isSelectFieldFormField = function () {
    return {
        selectWriteValue: writeValidValue,
        selectReadValue: function ($519) {
            return Restaumatic_Form_Final.unFinal(readValue($519));
        },
        selectGetOptions: readOptions(),
        selectTouch: touch
    };
};
var nonEmpty = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_Final.functorFinal)(function (s) {
    return Data_Monoid_Extra.mwhen(Data_Monoid.monoidArray)(s === "")([ Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.required) ]);
});
var monadFormDefM = Specular_FRP_Host.monadHost;
var monadEffectFormDefM = Specular_FRP_Host.monadEffectHost;
var normalize = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(monadEffectFormDefM)(writeRef(v1.normalize)(v));
    };
};
var onWriteValue = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(monadEffectFormDefM)(Effect_Ref.write(v)(v1.onWriteValue));
    };
};
var options = function () {
    return function (v) {
        return function (v1) {
            return Effect_Class.liftEffect(monadEffectFormDefM)(writeRef(v1.options)(Data_Leibniz.runLeibniz(Data_Leibniz.liftLeibniz(Data_Leibniz.symm(optionForEq())))(v)));
        };
    };
};
var validations = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(monadEffectFormDefM)(writeRef(v1.validations)(Data_Functor.map(Data_Functor.functorArray)(function (v2) {
            return v2(readValue(v1));
        })(v)));
    };
};
var monadCleanupFormDefM = Specular_FRP_Host.monadCleanupHost;
var modifyValidValue = function (v) {
    return function (update) {
        return function __do() {
            var old = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(Restaumatic_Form_Final.unFinal(readValue(v)))();
            writeValidValue(v)(update(old))();
            touch(v)();
            return v.userEdit.fire(Data_Unit.unit)();
        };
    };
};
var modify = function (v) {
    return function (update) {
        return function __do() {
            var old = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(Restaumatic_Form_Final.unFinal(readValue(v)))();
            if (old instanceof Data_Maybe.Nothing) {
                return Data_Unit.unit;
            };
            if (old instanceof Data_Maybe.Just) {
                writeValidValue(v)(update(old.value0))();
                touch(v)();
                return v.userEdit.fire(Data_Unit.unit)();
            };
            throw new Error("Failed pattern match at Restaumatic.Form (line 198, column 3 - line 204, column 27): " + [ old.constructor.name ]);
        };
    };
};
var mergeUnit = function (dictTypeEquals) {
    return {
        merge: function (v) {
            return function (v1) {
                return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
            };
        }
    };
};
var mergeRecordNil = {
    mergeRecord: function (v) {
        return function (v1) {
            return function (v2) {
                return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
            };
        };
    }
};
var mergeRecord = function (dict) {
    return dict.mergeRecord;
};
var merge_Record = function (dictAsRecord) {
    return function () {
        return function (dictMergeRecord) {
            return {
                merge: function (d) {
                    return function (f) {
                        return mergeRecord(dictMergeRecord)(Type_Proxy["Proxy"].value)(toRecord(dictAsRecord)(d))(f);
                    };
                }
            };
        };
    };
};
var mergeInputRequiredFormField = {
    mergeInputRequired: function (v) {
        return Specular_Ref.write(Effect_Class.monadEffectEffect)(v.value)(InputRequired.value);
    }
};
var mergeInputRequired = function (dict) {
    return dict.mergeInputRequired;
};
var mergeFormField = function (dictTypeEquals) {
    return {
        merge: function (x) {
            return function (v) {
                return Specular_Ref.write(Effect_Class.monadEffectEffect)(v.value)(new Valid({
                    value: Type_Equality.to(dictTypeEquals)(x),
                    editValue: Data_Maybe.Nothing.value
                }));
            };
        }
    };
};
var merge = function (dict) {
    return dict.merge;
};
var mergeRecordCons = function (dictIsSymbol) {
    return function (dictMergeRecord) {
        return function (dictMerge) {
            return function () {
                return function () {
                    return function () {
                        return function () {
                            return {
                                mergeRecord: function (v) {
                                    return function (r) {
                                        return function (f) {
                                            return function __do() {
                                                Specular_Profiling.measure(Effect_Class.monadEffectEffect)("merge " + Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value))(merge(dictMerge)(Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(r))(Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(f)))();
                                                return mergeRecord(dictMergeRecord)(Type_Proxy["Proxy"].value)(r)(f)();
                                            };
                                        };
                                    };
                                }
                            };
                        };
                    };
                };
            };
        };
    };
};
var mergeT2T2 = function (dictMerge) {
    return function (dictMerge1) {
        return {
            merge: function (v) {
                return function (v1) {
                    return function __do() {
                        merge(dictMerge)(v.value0)(v1.value0)();
                        return merge(dictMerge1)(v.value1)(v1.value1)();
                    };
                };
            }
        };
    };
};
var mapVFinal = function (f) {
    var $520 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Validation_Semigroup.validation(Data_Validation_Semigroup.invalid)(f));
    return function ($521) {
        return Restaumatic_Form_Final.makeFinalV($520(Restaumatic_Form_Final.unFinalV($521)));
    };
};
var mapMaybeFinalUserVisible = function (errorMessage) {
    return function (f) {
        var f$prime = function (x) {
            var v = f(x);
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Validation_Semigroup.invalid(Restaumatic_Form_Final.userVisibleError(errorMessage));
            };
            if (v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Restaumatic_Form_Final.semigroupFormErrors))(v.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Form (line 467, column 5 - line 469, column 23): " + [ v.constructor.name ]);
        };
        var $522 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Validation_Semigroup.validation(Data_Validation_Semigroup.invalid)(f$prime));
        return function ($523) {
            return Restaumatic_Form_Final.makeFinalV($522(Restaumatic_Form_Final.unFinalV($523)));
        };
    };
};
var mapMaybeFinalInternal = function (errorMessage) {
    return function (f) {
        var f$prime = function (x) {
            var v = f(x);
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Validation_Semigroup.invalid(Restaumatic_Form_Final.internalError(errorMessage));
            };
            if (v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Restaumatic_Form_Final.semigroupFormErrors))(v.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Form (line 477, column 5 - line 479, column 23): " + [ v.constructor.name ]);
        };
        var $524 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Validation_Semigroup.validation(Data_Validation_Semigroup.invalid)(f$prime));
        return function ($525) {
            return Restaumatic_Form_Final.makeFinalV($524(Restaumatic_Form_Final.unFinalV($525)));
        };
    };
};
var mapMaybeFinal = /* #__PURE__ */ mapMaybeFinalInternal("Unknown error (mapMaybeFinal)");
var mapDynamicFinal = function (f) {
    return function ($526) {
        return Restaumatic_Form_Final.makeFinalV((function (v) {
            return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(v)(Data_Traversable.traverse(Data_Validation_Semigroup.traversableV)(Specular_FRP_Base.applicativeDynamic)(f));
        })(Restaumatic_Form_Final.unFinalV($526)));
    };
};
var makeEmptyRecordNil = {
    makeEmptyRecord: function (v) {
        return function (v1) {
            return Control_Applicative.pure(Effect.applicativeEffect)(Control_Category.identity(Record_Builder.categoryBuilder));
        };
    }
};
var makeEmptyRecord = function (dict) {
    return dict.makeEmptyRecord;
};
var makeEmpty_Record = function () {
    return function (dictMakeEmptyRecord) {
        return {
            makeEmptyImpl: function (opts) {
                return function __do() {
                    var b = makeEmptyRecord(dictMakeEmptyRecord)(Type_Proxy["Proxy"].value)(opts)();
                    return Record_Builder.build(b)({});
                };
            }
        };
    };
};
var makeEmptyMaybe = /* #__PURE__ */ (function () {
    return {
        makeEmptyImpl: Control_Applicative.pure(Control_Applicative.applicativeFn)(Control_Applicative.pure(Effect.applicativeEffect)(Data_Maybe.Nothing.value))
    };
})();
var makeEmptyImpl = function (dict) {
    return dict.makeEmptyImpl;
};
var makeEmptyRecordCons = function (dictIsSymbol) {
    return function (dictMakeEmptyRecord) {
        return function (dictMakeEmpty) {
            return function () {
                return function () {
                    return {
                        makeEmptyRecord: function (v) {
                            return function (opts) {
                                return function __do() {
                                    var x = makeEmptyImpl(dictMakeEmpty)({
                                        name: Data_Semigroup.append(Data_Semigroup.semigroupArray)(opts.name)([ Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value) ])
                                    })();
                                    var xs = makeEmptyRecord(dictMakeEmptyRecord)(Type_Proxy["Proxy"].value)(opts)();
                                    return Control_Semigroupoid.composeFlipped(Record_Builder.semigroupoidBuilder)(xs)(Record_Builder.insert()()(dictIsSymbol)(Type_Proxy["Proxy"].value)(x));
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var makeEmptyT2 = function (dictMakeEmpty) {
    return function (dictMakeEmpty1) {
        return {
            makeEmptyImpl: function (opts) {
                return Control_Apply.apply(Effect.applyEffect)(Data_Functor.map(Effect.functorEffect)(Data_Tuple_T2.T2.create)(makeEmptyImpl(dictMakeEmpty)({
                    name: Data_Semigroup.append(Data_Semigroup.semigroupArray)(opts.name)([ "0" ])
                })))(makeEmptyImpl(dictMakeEmpty1)({
                    name: Data_Semigroup.append(Data_Semigroup.semigroupArray)(opts.name)([ "1" ])
                }));
            }
        };
    };
};
var makeEmpty = function (dictMonadEffect) {
    return function (dictMakeEmpty) {
        return Effect_Class.liftEffect(dictMonadEffect)(makeEmptyImpl(dictMakeEmpty)({
            name: [  ]
        }));
    };
};
var mSelectWriteValue = function (dict) {
    return dict.mSelectWriteValue;
};
var mSelectTouch = function (dict) {
    return dict.mSelectTouch;
};
var mSelectReadValue = function (dict) {
    return dict.mSelectReadValue;
};
var mSelectGetOptions = function (dict) {
    return dict.mSelectGetOptions;
};
var liftMaybe = /* #__PURE__ */ (function () {
    var $527 = Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
    return function ($528) {
        return Restaumatic_Form_Final.makeFinal($527($528));
    };
})();
var liftHost = function (dictMonadFRP) {
    return function (h) {
        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())(Specular_FRP_Host.runHost(h)))(function (v) {
            return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Control_Monad_Cleanup.onCleanup(dictMonadFRP.MonadCleanup1())(v.value1))(function () {
                return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(v.value0);
            });
        });
    };
};
var lessThanOrEqual = function (dictOrd) {
    return function (dictShow) {
        return Control_Apply.lift2(Restaumatic_Form_Final.applyFinal)(function (threshold) {
            return function (value) {
                return Data_Monoid_Extra.munless(Data_Monoid.monoidArray)(Data_Ord.lessThanOrEq(dictOrd)(value)(threshold))([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.lessThanOrEqual)({
                    threshold: Data_Show.show(dictShow)(threshold)
                }) ]);
            };
        });
    };
};
var lessThan = function (dictOrd) {
    return function (dictShow) {
        return Control_Apply.lift2(Restaumatic_Form_Final.applyFinal)(function (threshold) {
            return function (value) {
                return Data_Monoid_Extra.munless(Data_Monoid.monoidArray)(Data_Ord.lessThan(dictOrd)(value)(threshold))([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.lessThan)({
                    threshold: Data_Show.show(dictShow)(threshold)
                }) ]);
            };
        });
    };
};
var isSelectFieldRefWithOptions = function (dictIsRefLike) {
    return {
        selectWriteValue: function (v) {
            return function (value) {
                return writeRefLike(dictIsRefLike)(v.field)(new Valid({
                    value: value,
                    editValue: Data_Maybe.Nothing.value
                }));
            };
        },
        selectReadValue: function (v) {
            return readRefLike(dictIsRefLike)(v.field);
        },
        selectGetOptions: function (v) {
            return v.choices;
        },
        selectTouch: function (v) {
            return touchRefLike(dictIsRefLike)(v.field);
        }
    };
};
var isSelectFieldChoiceRef = {
    selectWriteValue: function (v) {
        return function (a) {
            return Specular_Ref.write(Effect_Class.monadEffectEffect)(v.field.currentChoice)(a);
        };
    },
    selectReadValue: function (v) {
        return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.Just.create)(Specular_Ref.value(Specular_ChoiceRef.currentChoice(v.field)));
    },
    selectGetOptions: function (v) {
        return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Functor.map(Data_Functor.functorArray)(v.toOption))(Specular_ChoiceRef.choices(v.field));
    },
    selectTouch: function (v) {
        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
    }
};
var isMultiSelectFieldMultiChoiceRef = {
    mSelectWriteValue: function (v) {
        return function (a) {
            return Specular_Ref.updateRef(Effect_Class.monadEffectEffect)(v.field.currentChoices)(a);
        };
    },
    mSelectReadValue: function (v) {
        return Specular_Ref.value(Specular_MultiChoiceRef.currentChoices(v.field));
    },
    mSelectGetOptions: function (v) {
        return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Functor.map(Data_Functor.functorArray)(v.toOption))(Specular_MultiChoiceRef.choices(v.field));
    },
    mSelectTouch: function (v) {
        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
    }
};
var hasOptionsSingle = {};
var hasOptionsSet = {};
var hasOptionsSMultiSet = {};
var hasOptionsArray = {};
var hasErrorsOldFormField = {
    displayedErrors: Specular_FormField.displayedErrors
};
var hasErrorsErrorArray = {
    displayedErrors: /* #__PURE__ */ unFinalWithDefault(/* #__PURE__ */ Data_Monoid.mempty(Data_Monoid.monoidArray))
};
var greaterThanOrEqual = function (dictOrd) {
    return function (dictShow) {
        return Control_Apply.lift2(Restaumatic_Form_Final.applyFinal)(function (threshold) {
            return function (value) {
                return Data_Monoid_Extra.munless(Data_Monoid.monoidArray)(Data_Ord.greaterThanOrEq(dictOrd)(value)(threshold))([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.greaterThanOrEqual)({
                    threshold: Data_Show.show(dictShow)(threshold)
                }) ]);
            };
        });
    };
};
var greaterThan = function (dictOrd) {
    return function (dictShow) {
        return Control_Apply.lift2(Restaumatic_Form_Final.applyFinal)(function (threshold) {
            return function (value) {
                return Data_Monoid_Extra.munless(Data_Monoid.monoidArray)(Data_Ord.greaterThan(dictOrd)(value)(threshold))([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.greaterThan)({
                    threshold: Data_Show.show(dictShow)(threshold)
                }) ]);
            };
        });
    };
};
var getFieldId = function (dict) {
    return dict.getFieldId;
};
var hasFieldIdRefWithOptions = function (dictHasFieldId) {
    return {
        getFieldId: function (v) {
            return getFieldId(dictHasFieldId)(v.field);
        }
    };
};
var genericTypedValue = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Undefined.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new Invalid(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new Valid(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return InputRequired.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Form (line 81, column 1 - line 81, column 62): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Undefined) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Invalid) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof Valid) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof InputRequired) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Restaumatic.Form (line 81, column 1 - line 81, column 62): " + [ x.constructor.name ]);
    }
};
var showTypedValue = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericTypedValue)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "Undefined";
            }
        }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()()(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "editValue";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "error";
            }
        })(Data_Show.showRecordFieldsNil)(Restaumatic_Form_Final.showFormErrors))(Data_Maybe.showMaybe(Data_Show.showString)))))({
            reflectSymbol: function () {
                return "Invalid";
            }
        }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()()(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "editValue";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "value";
            }
        })(Data_Show.showRecordFieldsNil)(dictShow))(Data_Maybe.showMaybe(Data_Show.showString)))))({
            reflectSymbol: function () {
                return "Valid";
            }
        }))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "InputRequired";
            }
        })))))
    };
};
var functorFormDefM = Specular_FRP_Host.functorHost;
var fromValid = function (v) {
    if (v instanceof Valid) {
        return new Data_Maybe.Just(v.value0.value);
    };
    return Data_Maybe.Nothing.value;
};
var fromRecord = function (dict) {
    return dict.fromRecord;
};
var query_Record = function (dictAsRecord) {
    return function () {
        return function (dictQueryRecord) {
            return {
                queryWith: function (strictness) {
                    return function (f) {
                        return Data_Functor.map(Restaumatic_Form_Final.functorFinal)((function () {
                            var $529 = fromRecord(dictAsRecord);
                            var $530 = Data_Function.flip(Record_Builder.build)({});
                            return function ($531) {
                                return $529($530($531));
                            };
                        })())(queryRecord(dictQueryRecord)(strictness)(Type_Proxy["Proxy"].value)(f));
                    };
                }
            };
        };
    };
};
var fromChoices = function (dictFoldable) {
    return function (dictIsRefLike) {
        return function (field) {
            return function (cs) {
                return {
                    field: field,
                    choices: Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(cs)(Data_Array.fromFoldable(dictFoldable)))(Data_Functor.map(Data_Functor.functorArray)(function (r) {
                        return singleOption(r.name)(r.id);
                    }))
                };
            };
        };
    };
};
var forceDisplayErrorsKey = /* #__PURE__ */ Data_Vault.unsafeNewKey(Data_Eq.eqInt);
var forceDisplayErrors = /* #__PURE__ */ Data_Vault.singleton(forceDisplayErrorsKey);
var fieldPathToString = /* #__PURE__ */ Data_String_Common.joinWith(".");
var fieldNameString = function (v) {
    return Data_String_Common.joinWith(".")(v.name);
};
var hasFieldIdFormField1 = {
    getFieldId: fieldNameString
};
var failFirst = function (validations_) {
    return function (value) {
        return Restaumatic_Form_Final.bindFinal(value)(function (value_) {
            var validationValuesD = Data_Functor.map(Data_Functor.functorArray)((function () {
                var $532 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.fromMaybe([  ]));
                return function ($533) {
                    return $532(Restaumatic_Form_Final.unFinal((function (v) {
                        return v(Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)(value_));
                    })($533)));
                };
            })())(validations_);
            var validationValues = Data_Traversable.sequence(Data_Traversable.traversableArray)(Specular_FRP_Base.applicativeDynamic)(validationValuesD);
            var findFirst = (function () {
                var $534 = Data_Maybe.fromMaybe([  ]);
                var $535 = Data_Foldable.find(Data_Foldable.foldableArray)(function (e) {
                    return Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(e) > 0;
                });
                return function ($536) {
                    return $534($535($536));
                };
            })();
            var result = Data_Functor.map(Specular_FRP_Base.functorDynamic)(function ($537) {
                return Data_Maybe.Just.create(findFirst($537));
            })(validationValues);
            return Restaumatic_Form_Final.makeFinal(result);
        });
    };
};
var eqStrictness = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Strict && y instanceof Strict) {
                return true;
            };
            if (x instanceof Lax && y instanceof Lax) {
                return true;
            };
            return false;
        };
    }
};
var encodeTypedValue = function (dictEncode) {
    return function (dictEncodeWithOptions) {
        return {
            encode: Foreign_Encoding.defaultEncode(genericTypedValue)(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
                reflectSymbol: function () {
                    return "Undefined";
                }
            })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
                reflectSymbol: function () {
                    return "Invalid";
                }
            })(Foreign_Generic_Class.genericEncodeArgsRecord(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                reflectSymbol: function () {
                    return "error";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Form_Final.encodeFormErrors)))({
                reflectSymbol: function () {
                    return "editValue";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode)))))))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
                reflectSymbol: function () {
                    return "Valid";
                }
            })(Foreign_Generic_Class.genericEncodeArgsRecord(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                reflectSymbol: function () {
                    return "value";
                }
            })(dictEncodeWithOptions))({
                reflectSymbol: function () {
                    return "editValue";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode)))))))(Foreign_Generic_Class.genericEncodeConstructor({
                reflectSymbol: function () {
                    return "InputRequired";
                }
            })(Foreign_Generic_Class.genericEncodeArgsNoArguments)))))
        };
    };
};
var dynamicFromContextDef = function (d) {
    return function (key) {
        return function (ctxRef) {
            return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(ctxRef))(function (context1) {
                return Data_Maybe.fromMaybe(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(d))(Data_Vault.lookup(key)(context1));
            });
        };
    };
};
var dynamicFromContext = function (key) {
    return function (ctxRef) {
        return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(ctxRef))(function (context1) {
            return Data_Traversable.sequence(Data_Traversable.traversableMaybe)(Specular_FRP_Base.applicativeDynamic)(Data_Vault.lookup(key)(context1));
        });
    };
};
var hasErrorsFormField = {
    displayedErrors: function (v) {
        return Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v1) {
            return function (v2) {
                return function (v3) {
                    var $446 = v1 || v2;
                    if ($446) {
                        return v3;
                    };
                    return [  ];
                };
            };
        })(Specular_Ref.value(v.touched)))(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.fromMaybe(false))(dynamicFromContext(forceDisplayErrorsKey)(v.context))))(readValidationErrors(v));
    }
};
var dumpStateRecordNil = {
    dumpStateRecord: function (v) {
        return function (v1) {
            return Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Foreign_Object.empty);
        };
    }
};
var dumpStateRecord = function (dict) {
    return dict.dumpStateRecord;
};
var dumpState_Record = function () {
    return function (dictDumpStateRecord) {
        return {
            dumpState: (function () {
                var $538 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Foreign_Generic_Class.encode(Foreign_Generic_Class.objectEncode(Foreign_Generic_Class.foreignEncode)));
                var $539 = dumpStateRecord(dictDumpStateRecord)(Type_Proxy["Proxy"].value);
                return function ($540) {
                    return $538($539($540));
                };
            })()
        };
    };
};
var dumpState = function (dict) {
    return dict.dumpState;
};
var dumpStateRecordCons = function (dictIsSymbol) {
    return function (dictDumpStateRecord) {
        return function (dictDumpState) {
            return function () {
                return function () {
                    return {
                        dumpStateRecord: function (v) {
                            return function (f) {
                                return Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v1) {
                                    return function (v2) {
                                        return Foreign_Object.insert(Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value))(v1)(v2);
                                    };
                                })(dumpState(dictDumpState)(Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(f))))(dumpStateRecord(dictDumpStateRecord)(Type_Proxy["Proxy"].value)(f));
                            };
                        }
                    };
                };
            };
        };
    };
};
var displayedErrors = function (dict) {
    return dict.displayedErrors;
};
var dumpStateFormField = function (dictEncode) {
    return function (dictEncode1) {
        return {
            dumpState: function (v) {
                return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "value";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(dictEncode1)))({
                    reflectSymbol: function () {
                        return "touched";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
                    reflectSymbol: function () {
                        return "readValue";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.foreignEncode)))({
                    reflectSymbol: function () {
                        return "readValidationErrors";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode))))({
                    reflectSymbol: function () {
                        return "displayedErrors";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode))))({
                    reflectSymbol: function () {
                        return "defaultValue";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(dictEncode))))))(Record_Extra.sequenceRecord()(Record_Extra.sequenceRecordCons({
                    reflectSymbol: function () {
                        return "defaultValue";
                    }
                })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                    reflectSymbol: function () {
                        return "displayedErrors";
                    }
                })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                    reflectSymbol: function () {
                        return "readValidationErrors";
                    }
                })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                    reflectSymbol: function () {
                        return "readValue";
                    }
                })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                    reflectSymbol: function () {
                        return "touched";
                    }
                })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordSingle({
                    reflectSymbol: function () {
                        return "value";
                    }
                })()(Specular_FRP_Base.functorDynamic)()())()())()())()())()())()())({
                    value: Specular_Ref.value(v.value),
                    defaultValue: Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(v.defaultValue))(Restaumatic_Form_Final.unFinal),
                    touched: Specular_Ref.value(v.touched),
                    readValue: Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.maybe(Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)("(NO READ VALUE)"))(Foreign_Generic_Class.encode(dictEncode)))(Restaumatic_Form_Final.unFinal(readValue(v))),
                    readValidationErrors: readValidationErrors(v),
                    displayedErrors: displayedErrors(hasErrorsFormField)(v)
                }));
            }
        };
    };
};
var hasDisplayedErrors = function (dictHasErrors) {
    var $541 = Data_Functor.map(Specular_FRP_Base.functorDynamic)((function () {
        var $544 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
        return function ($545) {
            return $544(Data_Array["null"]($545));
        };
    })());
    var $542 = displayedErrors(dictHasErrors);
    return function ($543) {
        return $541($542($543));
    };
};
var hasErrorsErrorMappedField = {
    displayedErrors: function (v) {
        return displayedErrors(hasErrorsFormField)(v.field);
    }
};
var hasErrorsRefWithOptions = function (dictHasErrors) {
    return {
        displayedErrors: function (v) {
            return displayedErrors(dictHasErrors)(v.field);
        }
    };
};
var hasErrorsWithId = function (dictHasErrors) {
    return {
        displayedErrors: function (v) {
            return displayedErrors(dictHasErrors)(v.value0.field);
        }
    };
};
var displayLocaleKey = /* #__PURE__ */ Data_Vault.unsafeNewKey(Data_Eq.eqInt);
var displayLocale = /* #__PURE__ */ Data_Vault.singleton(displayLocaleKey);
var defineForm = function (dictMonadFRP) {
    return function (v) {
        return liftHost(dictMonadFRP)(v);
    };
};
var define1 = function (f) {
    return function (v) {
        return v(f);
    };
};
var defaultWriteValue = function (v) {
    return function (v1) {
        return function __do() {
            writeRef(v.value)(v1)();
            writeRef(v.touched)(true)();
            return v.userEdit.fire(Data_Unit.unit)();
        };
    };
};
var newEmptyFormField = function (opts) {
    return function __do() {
        var label_ = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Restaumatic_Form_Final.invalidFinal)();
        var value = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Undefined.value)();
        var editValue = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Data_Maybe.Nothing.value)();
        var defaultValue1 = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Restaumatic_Form_Final.makeFinalV(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Validation_Semigroup.invalid(requiredError(Data_Unit.unit)))))();
        var touched = Specular_Ref["new"](Effect_Class.monadEffectEffect)(false)();
        var options1 = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)([  ]))();
        var validations1 = Specular_Ref["new"](Effect_Class.monadEffectEffect)([  ])();
        var context1 = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Data_Monoid.mempty(Data_Vault.monoidVault))();
        var normalize1 = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Control_Category.identity(Control_Category.categoryFn)))();
        var userEdit1 = Specular_FRP_Base.newEvent(Effect_Class.monadEffectEffect)();
        var onWriteValue_ = Effect_Ref["new"](defaultWriteValue)();
        var readValueState_ = Specular_FRP_Base.annotated("FormField.readValueState")(Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v) {
            return function (v1) {
                return function (v2) {
                    if (v2 instanceof Undefined) {
                        return Data_Validation_Semigroup.validation(function (e) {
                            return new Invalid({
                                error: Data_Semigroup.append(Restaumatic_Form_Final.semigroupFormErrors)(requiredError(Data_Unit.unit))(e),
                                editValue: Data_Maybe.Nothing.value
                            });
                        })(function (x) {
                            return new Valid({
                                value: x,
                                editValue: Data_Maybe.Nothing.value
                            });
                        })(v);
                    };
                    if (v2 instanceof Valid) {
                        return new Valid({
                            value: v1(v2.value0.value),
                            editValue: v2.value0.editValue
                        });
                    };
                    return v2;
                };
            };
        })(Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(defaultValue1))(Restaumatic_Form_Final.unFinalV)))(Control_Bind.join(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(normalize1))))(Specular_Ref.value(value)));
        Specular_FRP_Base.annotate(Effect_Class.monadEffectEffect)(Specular_Ref.value(value))("FormField.value")();
        Specular_FRP_Base.annotate(Effect_Class.monadEffectEffect)(Specular_Ref.value(touched))("FormField.touched")();
        return {
            name: opts.name,
            label: label_,
            value: value,
            defaultValue: defaultValue1,
            touched: touched,
            options: options1,
            validations: validations1,
            context: context1,
            normalize: normalize1,
            userEdit: userEdit1,
            readValueState: readValueState_,
            onWriteValue: onWriteValue_
        };
    };
};
var makeEmptyFormField = {
    makeEmptyImpl: newEmptyFormField
};
var defaultValue = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(monadEffectFormDefM)(writeRef(v1.defaultValue)(v));
    };
};
var copyStateFormField = {
    copyState: function (v) {
        return function (v1) {
            return Control_Bind.bind(Effect.bindEffect)(Specular_Ref.read(Effect_Class.monadEffectEffect)(v.value))(Specular_Ref.write(Effect_Class.monadEffectEffect)(v1.value));
        };
    }
};
var copyState = function (dict) {
    return dict.copyState;
};
var checkboxInput = function (dict) {
    return dict.checkboxInput;
};
var isCheckboxFieldMappedFiel = {
    checkboxInput: function (v) {
        return Control_Bind.bind(Specular_FRP_Host.bindHost)(checkboxInput(isCheckboxFieldFormFieldB1)(v.field))(function (v1) {
            return Control_Applicative.pure(Specular_FRP_Host.applicativeHost)({
                displayedValue: Data_Functor.map(Specular_FRP_Base.functorDynamic)(v.mapping)(v1.displayedValue),
                onChange: function ($546) {
                    return v1.onChange(v.mapping($546));
                }
            });
        });
    }
};
var isCheckboxFieldWithId = function (dictIsCheckboxField) {
    return {
        checkboxInput: function (v) {
            return checkboxInput(dictIsCheckboxField)(v.value0.field);
        }
    };
};
var bindFormDefM = Specular_FRP_Host.bindHost;
var asRecordRecord = {
    fromRecord: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn),
    toRecord: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn)
};
var asRecordNewtype = function () {
    return {
        fromRecord: Data_Newtype.wrap(),
        toRecord: Data_Newtype.unwrap()
    };
};
var applyFormDefM = Specular_FRP_Host.applyHost;
var semigroupFormDefM = function (dictSemigroup) {
    return {
        append: Control_Apply.lift2(applyFormDefM)(Data_Semigroup.append(dictSemigroup))
    };
};
var applicativeFormDefM = Specular_FRP_Host.applicativeHost;
var define = function (f) {
    return Data_Foldable.traverse_(applicativeFormDefM)(Data_Foldable.foldableArray)(define1(f));
};
var monoidFormDefM = function (dictMonoid) {
    return {
        mempty: Control_Applicative.pure(applicativeFormDefM)(Data_Monoid.mempty(dictMonoid)),
        Semigroup0: function () {
            return semigroupFormDefM(dictMonoid.Semigroup0());
        }
    };
};
var annotatedFinal = function (name) {
    var $547 = Specular_FRP_Base.annotated(name);
    return function ($548) {
        return Restaumatic_Form_Final.makeFinalV($547(Restaumatic_Form_Final.unFinalV($548)));
    };
};
var annotateFinal = function (dictMonadEffect) {
    var $549 = Specular_FRP_Base.annotate(dictMonadEffect);
    return function ($550) {
        return $549(Restaumatic_Form_Final.unFinal($550));
    };
};
var addContextRecordNil = {
    addContextRecord: function (v) {
        return function (v1) {
            return function (v2) {
                return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
            };
        };
    }
};
var addContextRecord = function (dict) {
    return dict.addContextRecord;
};
var addContext_Record = function () {
    return function (dictAddContextRecord) {
        return {
            addContext: addContextRecord(dictAddContextRecord)(Type_Proxy["Proxy"].value)
        };
    };
};
var addContextMaybe = {
    addContext: function (v) {
        return function (v1) {
            return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
        };
    }
};
var addContextFormField = {
    addContext: function (ctx) {
        return function (v) {
            return Specular_Callback.triggerCallback(Specular_Ref.modify(Effect_Class.monadEffectEffect)(v.context))(function (v1) {
                return Data_Semigroup.append(Data_Vault.semigroupVault)(ctx)(v1);
            });
        };
    }
};
var addContext = function (dict) {
    return dict.addContext;
};
var addContextRecordCons = function (dictIsSymbol) {
    return function (dictAddContextRecord) {
        return function (dictAddContext) {
            return function () {
                return function () {
                    return {
                        addContextRecord: function (v) {
                            return function (ctx) {
                                return function (f) {
                                    return function __do() {
                                        addContext(dictAddContext)(ctx)(Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(f))();
                                        return addContextRecord(dictAddContextRecord)(Type_Proxy["Proxy"].value)(ctx)(f)();
                                    };
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var context = function (dictAddContext) {
    return function (ctx) {
        return function (f) {
            return Effect_Class.liftEffect(monadEffectFormDefM)(addContext(dictAddContext)(ctx)(f));
        };
    };
};
var addContextT2 = function (dictAddContext) {
    return function (dictAddContext1) {
        return {
            addContext: function (ctx) {
                return function (v) {
                    return function __do() {
                        addContext(dictAddContext)(ctx)(v.value0)();
                        return addContext(dictAddContext1)(ctx)(v.value1)();
                    };
                };
            }
        };
    };
};
export {
    Attribute,
    FormDefM,
    FormField,
    MappedField,
    RefWithOptions,
    Strict,
    Lax,
    Undefined,
    Invalid,
    Valid,
    InputRequired,
    WithId,
    WithOptions,
    addContext,
    addContextRecord,
    annotateFinal,
    annotatedFinal,
    checkboxInput,
    context,
    copyState,
    defaultValue,
    defaultWriteValue,
    define,
    define1,
    defineForm,
    displayLocale,
    displayLocaleKey,
    displayedErrors,
    dumpState,
    dumpStateRecord,
    dynamicFromContext,
    dynamicFromContextDef,
    failFirst,
    fieldNameString,
    fieldPathToString,
    forceDisplayErrors,
    forceDisplayErrorsKey,
    fromChoices,
    fromRecord,
    fromValid,
    getFieldId,
    greaterThan,
    greaterThanOrEqual,
    hasDisplayedErrors,
    lessThan,
    lessThanOrEqual,
    liftHost,
    liftMaybe,
    mSelectGetOptions,
    mSelectReadValue,
    mSelectTouch,
    mSelectWriteValue,
    makeEmpty,
    makeEmptyImpl,
    makeEmptyRecord,
    mapDynamicFinal,
    mapMaybeFinal,
    mapMaybeFinalInternal,
    mapMaybeFinalUserVisible,
    mapVFinal,
    merge,
    mergeInputRequired,
    mergeRecord,
    modify,
    modifyValidValue,
    newEmptyFormField,
    nonEmpty,
    normalize,
    onWriteValue,
    optionForEq,
    options,
    query,
    queryLax,
    queryLaxWithDefault,
    queryRecord,
    queryWith,
    readOptions,
    readRefLike,
    readValidationErrors,
    readValue,
    readValueState,
    requiredError,
    selectGetOptions,
    selectInput,
    selectReadValue,
    selectTouch,
    selectWriteValue,
    singleOption,
    tagErrors,
    textInput,
    toRecord,
    touch,
    touchRefLike,
    unFinalFromContext,
    unFinalFromContextDef,
    unFinalWithDefault,
    uniqFinal,
    userEdit,
    validateJust,
    validateTrue,
    validateWhenJust,
    validations,
    withFinal_,
    withId,
    withOptions,
    writeRef,
    writeRefLike,
    writeValidValue,
    writeValue,
    writeValueNoTouch,
    genericTypedValue,
    showTypedValue,
    encodeTypedValue,
    hasErrorsFormField,
    hasErrorsOldFormField,
    hasErrorsErrorArray,
    hasErrorsErrorMappedField,
    hasErrorsWithId,
    hasErrorsRef,
    dumpStateFormField,
    dumpState_Record,
    dumpStateRecordNil,
    dumpStateRecordCons,
    makeEmptyMaybe,
    makeEmptyFormField,
    makeEmptyT2,
    makeEmpty_Record,
    makeEmptyRecordNil,
    makeEmptyRecordCons,
    asRecordRecord,
    asRecordNewtype,
    mergeFormField,
    mergeRef,
    mergeT2T2,
    mergeUnit,
    merge_Record,
    mergeInputRequiredFormField,
    mergeRecordNil,
    mergeRecordCons,
    eqStrictness,
    queryDynamic,
    queryFinal,
    queryRef,
    queryFormFieldI,
    queryFormField,
    queryT2T2,
    queryUnit,
    query_Record,
    queryRecordNil,
    queryRecordCons,
    addContextFormField,
    addContextFormField1,
    addContextRef,
    addContextEffect,
    addContextDynamic,
    addContext_Record,
    addContextT2,
    addContextMaybe,
    addContextRecordNil,
    addContextRecordCons,
    functorFormDefM,
    applyFormDefM,
    applicativeFormDefM,
    bindFormDefM,
    monadFormDefM,
    monadEffectFormDefM,
    monadCleanupFormDefM,
    semigroupFormDefM,
    monoidFormDefM,
    isTextFieldRefString,
    isTextFieldFormFieldStrin,
    isTextFieldFormField,
    isTextFieldWithId,
    hasOptionsArray,
    hasOptionsSet,
    hasOptionsSMultiSet,
    hasOptionsSingle,
    isSelectFieldFormField,
    isSelectFieldWithId,
    isRefLikeFormField,
    isRefLikeRef,
    isRefLikeFormField1,
    hasErrorsRefWithOptions,
    isRefLikeWithId,
    hasFieldIdRefWithOptions,
    isSelectFieldRefWithOptions,
    isSelectFieldChoiceRef,
    isMultiSelectFieldMultiChoiceRef,
    isCheckboxFieldWithId,
    isCheckboxFieldFormFieldB1,
    isCheckboxFieldRefBoolean,
    isCheckboxFieldMappedFiel,
    isCheckboxFieldFormFieldB,
    copyStateFormField,
    hasFieldIdString,
    hasFieldIdFormField1,
    hasFieldIdFormField,
    hasFieldIdWithId
};
export {
    parse,
    toString
} from "../Restaumatic.Form.EditAsString/index.js";
export {
    bindFinal,
    formErrorsToArray,
    getErrors,
    internalError,
    liftDynamic,
    makeFinal,
    makeFinalV,
    unFinal,
    unFinalV,
    userVisibleError
} from "../Restaumatic.Form.Final/index.js";
export {
    newIdGenerator
} from "../Restaumatic.Form.GenerateId/index.js";
export {
    OptGroup,
    SingleOption
} from "../Specular.Select/index.js";
//# sourceMappingURL=index.js.map
